const Locale = {
  EN: 'En',
  RU: 'Ru',
} as const;

type Locale = (typeof Locale)[keyof typeof Locale];

export default Locale;
